import { render, staticRenderFns } from "./playground-cta.vue?vue&type=template&id=4acbc27e&scoped=true"
import script from "./playground-cta.vue?vue&type=script&lang=js"
export * from "./playground-cta.vue?vue&type=script&lang=js"
import style0 from "./playground-cta.vue?vue&type=style&index=0&id=4acbc27e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acbc27e",
  null
  
)

/* custom blocks */
import block0 from "./playground-cta.vue?vue&type=custom&index=0&blockType=i18n&lang=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports